import { Box, Chip, Tooltip } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';
import { useEventos } from '../lib/eventos.js';

/** Una app de tiempo real que se queda muda sin decirlo miente al usuario.
 *  Este indicador está siempre visible, en todas las pantallas. */
export function EstadoConexion() {
  const { data, isError } = useQuery({
    queryKey: ['health'],
    queryFn: api.health,
    refetchInterval: 15_000,
  });
  // Que la API conteste no significa que los avisos estén llegando. Sin esto, con el
  // stream caído la barra seguía diciendo «Conectado» mientras las pantallas se quedaban
  // congeladas hasta el siguiente refresco periódico: exactamente la mentira que este
  // indicador existe para no contar.
  const enVivo = useEventos((s) => s.conectado);

  if (isError) return <Chip size="small" color="error" label="Sin conexión" />;
  if (!data) return <Chip size="small" label="Comprobando…" />;

  const caidos = [
    data.db !== 'ok' && 'base de datos',
    data.amule.status === 'down' && 'aMule',
    data.plex.status === 'down' && 'Plex',
    data.indexer.status === 'down' && 'HispaShare',
    // Con la colocación rota se puede buscar y descargar, pero nada llegará a la
    // biblioteca. Callarlo hasta que haya una película esperando es lo peor de ambos.
    data.colocacion.status === 'down' && 'colocación',
  ].filter(Boolean) as string[];

  const sinConfigurar = [
    data.amule.status === 'unconfigured' && 'aMule',
    data.plex.status === 'unconfigured' && 'Plex',
    data.indexer.status === 'unconfigured' && 'HispaShare',
  ].filter(Boolean) as string[];

  if (caidos.length) {
    return (
      <Tooltip title={`Con problemas: ${caidos.join(', ')}`}>
        <Chip size="small" color="error" label={`${caidos.length} con problemas`} />
      </Tooltip>
    );
  }
  if (sinConfigurar.length) {
    return (
      <Tooltip title={`Faltan por configurar: ${sinConfigurar.join(', ')}`}>
        <Chip size="small" color="warning" label="Sin configurar" />
      </Tooltip>
    );
  }
  if (!enVivo) {
    return (
      <Tooltip title="La API responde, pero no llegan avisos en vivo: las pantallas se actualizan solas cada 30 s hasta que vuelva.">
        <Chip size="small" color="warning" label="Sin avisos en vivo" />
      </Tooltip>
    );
  }
  return (
    <Box>
      <Chip size="small" color="success" label="Conectado" />
    </Box>
  );
}
